// Action types
const SET_ITEM = 'localStore/SET_ITEM';
const REMOVE_ITEM = 'localStore/REMOVE_ITEM';
const CLEAR = 'localStore/CLEAR';
export interface LocalStoreState {
  [key: string]: any;
}

// Actions
export interface SetItemAction {
  type: typeof SET_ITEM;
  key: string;
  value: any;
}

export interface RemoveItemAction {
  type: typeof REMOVE_ITEM;
  key: string;
}

export interface ClearAction {
  type: typeof CLEAR;
}
export type LocalStoreAction = SetItemAction | RemoveItemAction | ClearAction;

// Initial state
const initialState: LocalStoreState = {};

// Reducer
// Reducer
export function localStoreReducer(
    state: LocalStoreState = initialState,
    action: LocalStoreAction
): LocalStoreState {
  switch (action.type) {
    case SET_ITEM:
      try {
        localStorage.setItem(action.key, JSON.stringify(action.value));
      } catch (e) {
        console.warn('Failed to set localStorage', e);
      }
      return { ...state, [action.key]: action.value };

    case REMOVE_ITEM:
      try {
        localStorage.removeItem(action.key);
      } catch (e) {
        console.warn('Failed to remove localStorage', e);
      }
      const newState = { ...state };
      delete newState[action.key];
      return newState;

    case CLEAR:
      try {
        Object.keys(state).forEach((key) => localStorage.removeItem(key));
      } catch (e) {
        console.warn('Failed to clear localStorage', e);
      }
      return {};

    default:
      return state;
  }
}

// Action creators
export const setLocalItem = (key: string, value: any): SetItemAction => ({
  type: SET_ITEM,
  key,
  value,
});

export const removeLocalItem = (key: string): RemoveItemAction => ({
  type: REMOVE_ITEM,
  key,
});

export const clearLocalStore = (): ClearAction => ({
  type: CLEAR,
});